import api from "@/api";

import { GET_PERSONAL_ACCOUNT_INFO, GET_PERSONAL_ACCOUNTS } from "./types";

export default {
  [GET_PERSONAL_ACCOUNT_INFO]: async ({ commit }) => {
    const resp = await api.user.getPersonalAccountInfo();

    commit(GET_PERSONAL_ACCOUNT_INFO, await resp.data);
    return resp.data;
  },

  [GET_PERSONAL_ACCOUNTS]: async ({ commit, getters}) => {
    const username = getters.getUsername;
    const resp = await api.user.getPersonalAccounts(username);

    commit(GET_PERSONAL_ACCOUNTS, await resp.data);
    return resp.data;
  }
};
